import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import { useCadastroParecerReferencialStore } from './../../store/CadastroParecerReferencialStore';
import SdsFileUpload from '@/components/sds-file-upload/SdsFileUpload.vue';
import CardExpand from '@/views/components/CardExpand.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CamposEmenta',
  setup(__props) {

const store = useCadastroParecerReferencialStore();
const { parecerReferencial, acceptExtensions, listaArquivos, arquivoEnviado } =
  storeToRefs(store);

return { __sfc: true,store, parecerReferencial, acceptExtensions, listaArquivos, arquivoEnviado, SdsFileUpload, CardExpand }
}

})